import React from 'react'; 
import PageText from './PageText';
import PageLargeText from './PageLargeText';
import PageAnchoredText from './PageAnchoredText';
import PageHeadingRightText from './PageHeadingRightText';
import PageData from './PageData';
import PageGrid from './PageGrid';
import PageGuides from './PageGuides';
import PageVideo from './PageVideo';
import PageHistory from './PageHistory';
import PageTimeline from './PageTimeline';
import PageProjectList from './PageProjectList';
import PageProjectGrid from './PageProjectGrid';
import PageAccordionList from './PageAccordionList';
import PageTeam from './PageTeam';
import PageProjects from './PageProjects';
import PageListings from './PageListings';
import PageFeaturedListings from './PageFeaturedListings';
import PageMarketingSplash from './PageMarketingSplash';
import PageTestimonial from './PageTestimonial';
import PageContact from './PageContact';
import PagePlaces from './PagePlaces';
import PageVideoSplash from './PageVideoSplash';
import PageImageSplash from './PageImageSplash';
import PageCinemagraphSplash from './PageCinemagraphSplash';
import PagePartner from './PagePartner';
import PageNavigation from './PageNavigation';
import PageMrkIntro from './PageMrkIntro';
import PageMrkUsps from './PageMrkUsps';
import PageMrkBlog from './PageMrkBlog';
import PageMrkListings from './PageMrkListings';
import PageMrkProjects from './PageMrkProjects';
import PageMrkSpecialists from './PageMrkSpecialists';
import PageMrkSubscription from './PageMrkSubscription';

import WithConsumer from '../../context/WithConsumer';


const PageBlock = ({index,context}) => {
 	
 	const ctxSiteLoaded = () => context.siteLoaded;
    const siteLoaded = ctxSiteLoaded();
    
 	if (context.posts) {
	 	
    	const posts 		= () => context.posts;
		const post 			= posts()[0];
		const block 		= post.block[index]; 
		    
		let content = '';
				
		if (block.type == 'text') {
		
		    content = <PageText block={block}></PageText>
		    
		} else if (block.type == 'large_text') {
		
		    content = <PageLargeText block={block}></PageLargeText>
		    
		} else if (block.type == 'anchored_text') {
		
		    content = <PageAnchoredText block={block}></PageAnchoredText>
		    
		} else if (block.type == 'heading_right_text') {
		
		    content = <PageHeadingRightText block={block}></PageHeadingRightText>
		    
		} else if (block.type == 'data') {
		
		    content = <PageData block={block}></PageData>
		    
		} else if (block.type == 'grid') {
		
		    content = <PageGrid block={block}></PageGrid>
		    
		} else if (block.type == 'grid') {
		
		    content = <PageGrid block={block}></PageGrid>
		    
		} else if (block.type == 'guides') {
		
		    content = <PageGuides block={block}></PageGuides>
		    
		} else if (block.type == 'history') {
		
		    content = <PageHistory block={block}></PageHistory>
		    
		} else if (block.type == 'timeline') {
		
		    content = <PageTimeline block={block}></PageTimeline>
		    
		} else if (block.type == 'project-list') {
		
		    content = <PageProjectList block={block}></PageProjectList>
		    
		} else if (block.type == 'project-grid') {
		
		    content = <PageProjectGrid block={block}></PageProjectGrid>
		    
		} else if (block.type == 'accordion-list') {
		
		    content = <PageAccordionList block={block}></PageAccordionList>
		    
		} else if (block.type == 'listings') {
		
		    content = <PageListings block={block}></PageListings>
		    
		} else if (block.type == 'featured_listings') {
		
		    content = <PageFeaturedListings block={block}></PageFeaturedListings>
		    
		} else if (block.type == 'projects') {
		
		    content = <PageProjects block={block}></PageProjects>
		    
		} else if (block.type == 'marketing_splash') {
		
		    content = <PageMarketingSplash block={block}></PageMarketingSplash>
		    
		} else if (block.type == 'testimonial') {
		
		    content = <PageTestimonial block={block}></PageTestimonial>
		    
		} else if (block.type == 'contact') {
					
		    content = <PageContact block={block}></PageContact>
		    
		} else if (block.type == 'places') {
		
		    content = <PagePlaces block={block}></PagePlaces>
		    
		} else if (block.type == 'team') {
		
		    content = <PageTeam block={block}></PageTeam>
		    
		} else if (block.type == 'video_splash') {
		
		    content = <PageVideoSplash block={block} siteLoaded={siteLoaded}></PageVideoSplash>
		    
		} else if (block.type == 'cinemagraph_splash') {
		
		    content = <PageCinemagraphSplash block={block}></PageCinemagraphSplash>
		    
		} else if (block.type == 'image_splash') {
		
		    content = <PageImageSplash block={block}></PageImageSplash>
		    
		}  else if (block.type == 'video') {
		
		    content = <PageVideo block={block}></PageVideo>
		    
		}  else if (block.type == 'partner') {
		
		    content = <PagePartner block={block}></PagePartner>
		    
		}  else if (block.type == 'page_navigation') {
		
		    content = <PageNavigation block={block}></PageNavigation>
		    
		} else if (block.type == 'mrk_intro') {
		
		    content = <PageMrkIntro block={block}></PageMrkIntro>
		    
		} else if (block.type == 'mrk_usps') {
		
		    content = <PageMrkUsps block={block}></PageMrkUsps>
		    
		} else if (block.type == 'mrk_blog') {
		
		    content = <PageMrkBlog block={block}></PageMrkBlog>
		    
		} else if (block.type == 'mrk_listings') {
		
		    content = <PageMrkListings block={block}></PageMrkListings>
		    
		} else if (block.type == 'mrk_projects') {
		
		    content = <PageMrkProjects block={block}></PageMrkProjects>
		    
		} else if (block.type == 'mrk_specialists') {
		
		    content = <PageMrkSpecialists block={block}></PageMrkSpecialists>
		    
		} else if (block.type == 'mrk_subform') {
		
		    content = <PageMrkSubscription block={block}></PageMrkSubscription>
		    
		}
    
		return content;
		
    } else {
	    
	    return null;
	    
    }

    

};
export default WithConsumer(PageBlock);